import { useState, useEffect } from "react";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { initializeConfig } from "../config";

// Create a placeholder for the S3Client to be initialized later
let s3Client = null;

export function useS3SignedUrl(bucketName, key) {
  const [signedUrl, setSignedUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clientReady, setClientReady] = useState(false);

  // First, initialize the S3 client with proper credentials
  useEffect(() => {
    const setupClient = async () => {
      if (s3Client) {
        setClientReady(true);
        return;
      }

      try {
        const config = await initializeConfig();
        s3Client = new S3Client({
          region: config.aws.region,
          credentials: {
            accessKeyId: config.aws.credentials.accessKeyId,
            secretAccessKey: config.aws.credentials.secretAccessKey,
          },
        });
        setClientReady(true);
      } catch (err) {
        console.error("Failed to initialize S3 client:", err);
        setError(err);
        setIsLoading(false);
      }
    };

    setupClient();
  }, []);

  // Then generate the signed URL once client is ready and we have bucket/key
  useEffect(() => {
    // Skip if client isn't ready or missing required parameters
    if (!clientReady || !bucketName || !key) {
      return;
    }

    let isMounted = true;
    setIsLoading(true);
    setError(null);

    const generateSignedUrl = async () => {
      try {
        console.log(
          `Generating signed URL for bucket: ${bucketName}, key: ${key}`
        );

        const command = new GetObjectCommand({
          Bucket: bucketName,
          Key: key,
        });

        const url = await getSignedUrl(s3Client, command, {
          expiresIn: 3600,
        });

        console.log(`Generated signed URL successfully`);
        console.log("url", url);
        if (isMounted) {
          setSignedUrl(url);
          setIsLoading(false);
        }
      } catch (err) {
        console.error(`Error generating URL for ${key}:`, err);
        if (isMounted) {
          setError(err);
          setIsLoading(false);
        }
      }
    };

    generateSignedUrl();

    return () => {
      isMounted = false;
    };
  }, [bucketName, key, clientReady]);

  return { signedUrl, isLoading, error };
}



